<template>
    <div class="wrap">
        <div class="container">
            <!-- <img class="back1"  @click="$router.back()"  src="../images/fanhui1.png" mode="heightFix" alt=""> -->
            <!-- <div class="returns" @click="$router.back()">返回</div> -->
            <!-- <div class="ysousuo">
                <img class="back1"  @click="$router.back()"  src="../images/fanhui1.png" mode="heightFix" alt="">
                <div class="">
                    <van-search  class="sousuos" placeholder="搜索订单" v-model="serch" />
                </div>
            </div> -->
            <div class="orders">
                <van-tabs v-model="status" @click="changeStatus">
                   
                    
                    <van-tab title="全部" name="All" >
                        <!-- <div style="width: 100%;display: flex;justify-content: center;" v-if="order_list.All.length==0">
                                <img style="height: 98px;margin: 70px auto 0 auto;" src="../images/nodd.png" alt="">
                         </div> -->
                        <van-list v-model="loading" loading-text="加载中..." :finished="finished" finished-text="没有更多了..." @load="loadPage" >
                            
                            <div class="order_goods_box" v-for="order in order_list.All" :key="order.id">
                                <div class="order-goods" style="background: #fff;border: none;">
                                   
                                    <!-- <div class="order-goods-order">
                                        <ul>
                                            <li>
                                                <router-link :to="{path:'/orderdetail', query:{id: order.id}}">
                                                    <span>订单号:{{ order.order_no }}</span>
                                                    <van-icon class="fr" name="arrow" /></router-link>
                                            </li>
                                            <li>日期:&nbsp;{{ order.add_time_date }}</li>
                                            <li>
                                                <van-row type="flex" justify="start">状态:&nbsp;
                                                    <van-row class="of_time" type="flex">{{ status_map[order.status].name }}&nbsp;&nbsp;</van-row></van-row>
                                            </li>
                                        </ul>
                                    </div> -->
                                    <ul class="order-goods-img f-clearfix">
                                        <li v-for="(goods,gindex) in order.items" :key="goods.id">
                                            <router-link :to="{path:'details',query:{id:goods.goods_id}}" >
                                                <div style="display: flex">
                                                    <van-image width="155" lazy-load :src="goods.images" />
                                                    <div  style="display: flex;flex-direction: column;justify-content: space-between" :style="gindex!= order.items.length-1?'justify-content: flex-start':''">

                                                       <div style="color: #000;line-height:22px;margin-top: 5px;margin-left: 15px;font-size: 16px;"> {{ order.items[0].title }}</div>
                                                       <div style="color: #14142B;font-size: 14px; margin-left: 15px;line-height:25px;margin-top: -20px" :style="gindex!= order.items.length-1?'margin-top: 12px':''">{{ order.items[0].spec[0].value }}
                                                            <span style=" margin-left: 5px">{{ order.items[0].spec[1].value }}</span>
                                                            <span style=" margin-left: 5px">数量</span>
                                                            <span style=" margin-left: 2px">{{ order.items[0].buy_number }}</span>
                                                        </div>
                                                        <div class="order-goods-total" v-if="gindex== order.items.length-1" style="margin-right: -20px;color: #000;text-align: right;padding-right: 10px;font-family: Songti SC, Songti SC; font-size: 13px;font-weight: 400;">实付款 ￥ 
                                                            <span style="font-size: 20px;font-weight: blod;"> {{ order.total_price }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                            </router-link>
                                        </li>
                                    </ul>
                                    <!-- <ul class="order-goods-img f-clearfix">
                                        <li v-for="goods in order.items" :key="goods.id">
                                            <router-link :to="{path:'details',query:{id:goods.goods_id}}">
                                                <van-image width="77" lazy-load :src="goods.images" />
                                            </router-link>
                                        </li>
                                    </ul> -->
                                   
                                    <div class="order-goods-buy">
                                        <van-row type="flex" align="center" justify="end">
                                            <van-col>
                                                <van-button size="small" type="primary" v-if="order.status == 1" @click="to_pay(order.id)">继续付款</van-button>
                                                <van-button size="small" type="primary" v-if="order.status > 2 && order.status < 5" :to="{path:'logistics',query:{id:order.id}}">查看物流</van-button>
                                                <van-button size="small" type="primary" v-if="order.status >= 5" @click="deleteOrder(order.id)">删除订单</van-button>
                                            </van-col>
                                        </van-row>
                                    </div>
                                    <div class="userOrder-trackBox">
                                        <div class="" v-if="order.status <= 1">
                                            <a href="javascript:;" class="cancel" @click="cancelOrder(order.id)">取消订单</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </van-list>
                    </van-tab>
                    <van-tab title="待支付" name="Unpaid">
                        <van-list v-model="loading" loading-text="加载中..." :finished="finished" finished-text="没有更多了..." @load="loadPage">
                            <div class="order_goods_box" v-for="order in order_list.Unpaid" :key="order.id">
                                <div class="order-goods"  style="background: #fff;border: none;">
                                    <!-- <div class="order-goods-order">
                                        <ul>
                                            <li>
                                                <router-link :to="{path:'/orderdetail', query:{id: order.id}}">
                                                    <span>订单号:{{ order.order_no }}{{ order.items[0].buy_number }}</span>
                                                    <van-icon class="fr" name="arrow" /></router-link>
                                            </li>
                                            <li>日期:&nbsp;{{ order.add_time_date }}</li>
                                            <li>
                                                <van-row type="flex" justify="start">状态:&nbsp;<van-row class="of_time" type="flex">{{ status_map[order.status].name }}&nbsp;&nbsp;</van-row></van-row>
                                            </li>
                                        </ul>
                                    </div> -->
                                    
                                    <ul class="order-goods-img f-clearfix">
                                        <li v-for="(goods,gindex) in order.items" :key="goods.id">
                                            <router-link :to="{path:'details',query:{id:goods.goods_id}}" >
                                                <div style="display: flex">
                                                    <van-image width="155" lazy-load :src="goods.images" />
                                                    <div  style="display: flex;flex-direction: column;justify-content: space-between" :style="gindex!= order.items.length-1?'justify-content: flex-start':''">

                                                       <div style="color: #000;line-height:22px;margin-top: 5px;margin-left: 15px;font-size: 16px;"> {{ order.items[0].title }}</div>
                                                       <div style="color: #14142B;font-size: 14px; margin-left: 15px;line-height:25px;margin-top: -20px" :style="gindex!= order.items.length-1?'margin-top: 12px':''">{{ order.items[0].spec[0].value }}
                                                            <span style=" margin-left: 5px">{{ order.items[0].spec[1].value }}</span>
                                                            <span style=" margin-left: 5px">数量</span>
                                                            <span style=" margin-left: 2px">{{ order.items[0].buy_number }}</span>
                                                        </div>
                                                        <div class="order-goods-total" v-if="gindex== order.items.length-1" style="margin-right: -20px;color: #000;text-align: right;padding-right: 10px;font-family: Songti SC, Songti SC; font-size: 13px;font-weight: 400;">实付款 ￥ 
                                                            <span style="font-size: 20px;font-weight: blod;"> {{ order.total_price }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                            </router-link>
                                        </li>
                                    </ul>
                                    <!-- <div class="order-goods-total" style="text-align: right;padding-right: 10px;font-family: Songti SC, Songti SC; font-size: 13px;font-weight: 400;">实付款 ￥ 
                                        <span style="font-size: 20px;font-weight: blod;"> {{ order.total_price }}</span>
                                    </div> -->
                                    <div class="order-goods-buy">
                                        <van-row type="flex" align="center" justify="end">
                                            <van-col>
                                                    <van-button size="small" type="primary" v-if="order.status == 1" @click="to_pay(order.id)">继续付款</van-button>
                                                    <van-button size="small" type="primary" v-if="order.status > 2 && order.status < 5" :to="{path:'logistics',query:{id:order.id}}">查看物流</van-button>
                                                    <van-button size="small" type="primary" v-if="order.status >= 5" @click="deleteOrder(order.id)">删除订单</van-button>
                                            </van-col>
                                                </van-row>
                                    </div>
                                    <div class="userOrder-trackBox">
                                        <div class="" v-if="order.status <= 1">
                                            <a href="javascript:;" class="cancel" @click="cancelOrder(order.id)">取消订单</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </van-list>
                    </van-tab>
                    <van-tab title="待收货" name="Paid">
                        <van-list v-model="loading" loading-text="加载中..." :finished="finished" finished-text="没有更多了..." @load="loadPage">
                            <div class="order_goods_box" v-for="order in order_list.Paid" :key="order.id">
                                <div class="order-goods">
                                    <div class="order-goods-order">
                                        <ul>
                                            <li>
                                                <router-link :to="{path:'/orderdetail', query:{id: order.id}}">
                                                    <span>订单号:{{ order.order_no }}</span>
                                                    <van-icon class="fr" name="arrow" /></router-link>
                                            </li>
                                            <li>日期:&nbsp;{{ order.add_time_date }}</li>
                                            <li>
                                                <van-row type="flex" justify="start">状态:&nbsp;
                                                    <van-row class="of_time" type="flex">{{ status_map[order.status].name }}&nbsp;&nbsp;</van-row></van-row>
                                            </li>
                                        </ul>
                                    </div>
                                    <ul class="order-goods-img f-clearfix">
                                        <li v-for="goods in order.items" :key="goods.id">
                                            <router-link :to="{path:'details',query:{id:goods.goods_id}}">
                                                <van-image width="77" lazy-load :src="goods.images" />
                                            </router-link>
                                        </li>
                                    </ul>
                                    <div class="order-goods-total">总价: :
                                        <span>￥ {{ price_symbol }} {{ order.total_price }}</span></div>
                                    <div class="order-goods-buy">
                                        <van-row type="flex" align="center" justify="end">
                                            <van-col>
                                                <van-button size="small" type="primary" v-if="order.status == 1" @click="to_pay(order.id)">继续付款</van-button>
                                                <van-button size="small" type="primary" v-if="order.status > 2 && order.status < 5" :to="{path:'logistics',query:{id:order.id}}">查看物流</van-button>
                                                <van-button size="small" type="primary" v-if="order.status >= 5" @click="deleteOrder(order.id)">删除订单</van-button>
                                            </van-col>
                                        </van-row>
                                    </div>
                                    <div class="userOrder-trackBox">
                                        <div class="" v-if="order.status <= 1">
                                            <a href="javascript:;" class="cancel" @click="cancelOrder(order.id)">取消订单</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </van-list>
                    </van-tab>
                    <van-tab title="已完成" name="Received">
                        <van-list v-model="loading" loading-text="加载中..." :finished="finished" finished-text="没有更多了..." @load="loadPage">
                            <div class="order_goods_box" v-for="order in order_list.Received" :key="order.id">
                                <div class="order-goods">
                                    <div class="order-goods-order">
                                        <ul>
                                            <li>
                                                <router-link :to="{path:'/orderdetail', query:{id: order.id}}">
                                                    <span>订单号:{{ order.order_no }}</span>
                                                    <van-icon class="fr" name="arrow" /></router-link>
                                            </li>
                                            <li>日期:&nbsp;{{ order.add_time_date }}</li>
                                            <li>
                                                <van-row type="flex" justify="start">状态:&nbsp;
                                                    <van-row class="of_time" type="flex">{{ status_map[order.status].name }}&nbsp;&nbsp;</van-row></van-row>
                                            </li>
                                        </ul>
                                    </div>
                                    <ul class="order-goods-img f-clearfix">
                                        <li v-for="goods in order.items" :key="goods.id">
                                            <router-link :to="{path:'details',query:{id:goods.goods_id}}">
                                                <van-image width="77" lazy-load :src="goods.images" />
                                            </router-link>
                                        </li>
                                    </ul>
                                    <div class="order-goods-total">总价: :
                                        <span>￥ {{ price_symbol }} {{ order.total_price }}</span></div>
                                    <div class="order-goods-buy">
                                        <van-row type="flex" align="center" justify="end">
                                            <van-col>
                                                <van-button size="small" type="primary" v-if="order.status == 1" @click="to_pay(order.id)">继续付款</van-button>
                                                <van-button size="small" type="primary" v-if="order.status > 2 && order.status < 5" :to="{path:'logistics',query:{id:order.id}}">查看物流</van-button>
                                                <van-button size="small" type="primary" v-if="order.status >= 5" @click="deleteOrder(order.id)">删除订单</van-button>
                                            </van-col>
                                        </van-row>
                                    </div>
                                    <div class="userOrder-trackBox">
                                        <div class="" v-if="order.status <= 1">
                                            <a href="javascript:;" class="cancel" @click="cancelOrder(order.id)">取消订单</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </van-list>
                    </van-tab>
                    <van-tab title="已取消" name="Expired">
                        <van-list v-model="loading" loading-text="加载中..." :finished="finished" finished-text="没有更多了..." @load="loadPage">
                            <div class="order_goods_box" v-for="order in order_list.Expired" :key="order.id">
                                <div class="order-goods"  style="background: #fff;border: none;">
                                    <!-- <div class="order-goods-order">
                                        <ul>
                                            <li>
                                                <router-link :to="{path:'/orderdetail', query:{id: order.id}}">
                                                    <span>订单号:{{ order.order_no }}</span>
                                                    <van-icon class="fr" name="arrow" /></router-link>
                                            </li>
                                            <li>日期:&nbsp;{{ order.add_time_date }}</li>
                                            <li>
                                                <van-row type="flex" justify="start">状态:&nbsp;
                                                    <van-row class="of_time" type="flex">{{ status_map[order.status].name }}&nbsp;&nbsp;</van-row></van-row>
                                            </li>
                                        </ul>
                                    </div> -->
                                    <ul class="order-goods-img f-clearfix">
                                        <li v-for="(goods,gindex) in order.items" :key="goods.id">
                                            <router-link :to="{path:'details',query:{id:goods.goods_id}}" >
                                                <div style="display: flex">
                                                    <van-image width="155" lazy-load :src="goods.images" />
                                                    <div  style="display: flex;flex-direction: column;justify-content: space-between" :style="gindex!= order.items.length-1?'justify-content: flex-start':''">

                                                       <div style="color: #000;line-height:22px;margin-top: 5px;margin-left: 15px;font-size: 16px;"> {{ order.items[0].title }}</div>
                                                       <div style="color: #14142B;font-size: 14px; margin-left: 15px;line-height:25px;margin-top: -20px" :style="gindex!= order.items.length-1?'margin-top: 12px':''">{{ order.items[0].spec[0].value }}
                                                            <span style=" margin-left: 5px">{{ order.items[0].spec[1].value }}</span>
                                                            <span style=" margin-left: 5px">数量</span>
                                                            <span style=" margin-left: 2px">{{ order.items[0].buy_number }}</span>
                                                        </div>
                                                        <div class="order-goods-total" v-if="gindex== order.items.length-1" style="margin-right: -20px;color: #000;text-align: right;padding-right: 10px;font-family: Songti SC, Songti SC; font-size: 13px;font-weight: 400;">实付款 ￥ 
                                                            <span style="font-size: 20px;font-weight: blod;"> {{ order.total_price }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                            </router-link>
                                        </li>
                                    </ul>
                                    <!-- <div class="order-goods-total" style="text-align: right;padding-right: 10px;font-family: Songti SC, Songti SC; font-size: 13px;font-weight: 400;">实付款 ￥ 
                                        <span style="font-size: 20px;font-weight: blod;"> {{ order.total_price }}</span>
                                    </div> -->
                                    <div class="order-goods-buy">
                                        <van-row type="flex" align="center" justify="end">
                                            <van-col>
                                                <van-button size="small" type="primary" v-if="order.status == 1" @click="to_pay(order.id)">继续付款</van-button>
                                                <van-button size="small" type="primary" v-if="order.status > 2 && order.status < 5" :to="{path:'logistics',query:{id:order.id}}">查看物流</van-button>
                                                <van-button size="small" type="primary" v-if="order.status >= 5" @click="deleteOrder(order.id)">删除订单</van-button>
                                            </van-col>
                                        </van-row>
                                    </div>
                                    <div class="userOrder-trackBox">
                                        <div class="" v-if="order.status <= 1">
                                            <a href="javascript:;" class="cancel" @click="cancelOrder(order.id)">取消订单</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </van-list>
                    </van-tab>
                </van-tabs>
            </div>
        </div>
        <v-foot></v-foot>
    </div>
</template>
<style scoped>
:deep(.van-tabs__line){
    background:#fff;
}
.ysousuo{
    display: flex;
    align-items: center;
    margin-top: 10px;
}
:deep(.van-search__content){
    border: 1px solid #BFC0C0;
    border-radius:10px;
    height: 35px;
    width: 276px;
    width: 276px;
    background: rgba(255,255,255,0.4);
    color: #BFC0C0;
}
.sousuos{
    /* width: 266px; */
/* height: 40px; */
background: rgba(255,255,255,0.4);
border-radius:12px;
/* border: 1px solid #BFC0C0; */
/* margin-top: 0px; */
margin-left: 10px;
}
:deep(.van-tab--active){
    font-size: 17px;
    font-weight: 600;
}
.returns{
	/* padding: 20px; */
	width: 50px;
	height: 30px;
	border: 1px solid #ebedf0;
	font-size: 16px;
	color: #000;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-left: 15px;
	border-radius: 4px;
}
.back1{
    height: 26px;
    /* margin-left: 25px; */
    margin: 10px 0 10px 25px;
  }
</style>
<script>// @ is an alias to /src
    export
default {
        components:
        {},
        data() {
            return {
                status: 'All',
                //订单状态
                order_list: {
                    'All': [],
                    'Unpaid': [],
                    'Paid': [],
                    'Received': [],
                    'Expired': []
                },
                //订单列表
                name_map: {
                    'All': '-1',
                    'Unpaid': '1',
                    'Paid': '2-3',
                    'Received': '4',
                    'Expired': '5'
                },
                status_map: [],
                //订单状态标识
                loading: false,
                finished: false,
                page: 1,
                price_symbol: '',
                serch:''
            }
        },
        created() {
            if(this.$route.query?.name){
                this.status=this.$route.query.name
            }
            this.getjiant()
        },
        methods: {
            getjiant(){
                this.GET("api/agreement/maidian?type=order", function (data) {
                    if (data.code == 0) {
                    console.log(data);
                    }
                });
            },
            loadPage() {
                var _this = this,
                status = _this.name_map[_this.status];
                var url = '/api/user/myorder?user_type=user&page=' + _this.page + '&status=' + status + '&is_more=1';
                this.GET(url,
                function(res) {
                    if (res.data.order_list.length > 0) {
                        _this.order_list[_this.status] = _this.order_list[_this.status].concat(res.data.order_list);
                        _this.status_map = res.data.common_order_user_status;
                        _this.price_symbol = res.data.price_symbol;
                        _this.page++;
                    } else {
                        _this.page = 1;
                        _this.finished = true;
                    }
                    _this.loading = false;
                })
            },
            changeStatus(name) {
                var _this = this;
                _this.status = name;
                _this.page = 1;
                _this.finished = false;
                _this.loading = false;
                _this.order_list[_this.status] =[]
            },
            to_pay(order_id){
                var _this = this
                this.POST('api/order/pay',{id:order_id},function (ret){
                    _this.$toast.loading({
                        message: '加载中...',
                        forbidClick: true,
                    });
                    // if(ret.code === 0){
                    //     window.location.href = ret.data.data;
                    // }
                    if (ret.code === -1) {
                        _this.$toast.fail(ret.msg);                     
                    }
                })
            },
            cancelOrder(id){
                var _self = this;
                this.$dialog.confirm({
                    title: '提示',
                    message: '您确定要这样做吗？'
                }).then(()=>{
                    this.POST('api/order/cancel',{id:id},function (ret){
                        if(ret.code === 0){
                            _self.$toast(ret.msg);
                            setTimeout(function (){
                                window.location.reload();
                            },500)

                        }else{
                            _self.$toast(ret.msg);
                        }
                    })
                })

            },
            deleteOrder(id){
                var _self = this;
                this.$dialog.confirm({
                    title: '提示',
                    message: '您确定要这样做吗？'
                }).then(()=>{
                    this.POST('api/order/delete',{id:id},function (ret){
                        if(ret.code === 0){
                            _self.$toast(ret.msg);
                            setTimeout(function (){
                                window.location.reload();
                            },500)

                        }else{
                            _self.$toast(ret.msg);
                        }
                    })
                })

            }
        },
    }</script>